import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 p-4">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-sm text-gray-700">
              Ta spletna stran uporablja samo nujne tehnične piškotke, ki so potrebni za pravilno delovanje strani. 
              Ne uporabljamo sledilnih ali analitičnih piškotkov. Več o tem v naši{' '}
              <a href="/politika-zasebnosti" className="text-atren-orange-dark hover:underline">
                politiki zasebnosti
              </a>.
            </p>
          </div>
          <div className="flex gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={rejectCookies}
              className="text-sm"
            >
              Zavrni
            </Button>
            <Button
              size="sm"
              onClick={acceptCookies}
              className="text-sm bg-atren-orange hover:bg-atren-orange/90"
            >
              Sprejmi
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;